export const dom = {
    /**
     * Finds the element rendered on the screen at the provided coordinates.
     * Similar to document.elementFromPoint, but pierces through shadow roots.
     * 
     * @param {number} x The X coordinate of the element (horizontal)
     * @param {number} y The Y coordinate of the element (vertical)
     * Returns the element rendered at the point
     */
    deepTargetFind(x, y) {
        let node = document.elementFromPoint(x, y);
        let next = node;
        // this code path is only taken when native ShadowDOM is used
        // if there is a shadowroot, it may have a node at x/y
        // if there is not a shadowroot, exit the loop
        while (next && next.shadowRoot && !window.ShadyDOM) {
        // if there is a node at x/y in the shadowroot, look deeper
        let oldNext = next;
        next = next.shadowRoot.elementFromPoint(x, y);
        // on Safari, elementFromPoint may return the shadowRoot host
        if (oldNext === next) {
            break;
        }
        if (next) {
            node = next;
        }
        }
        return node;
    }
};